import {Component, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, ComplianceAreaService, TenantService,} from '../../_services/index';

import {Company, ComplianceArea, User} from '../../_models/index';

import {CompanyType, Role} from '../../helpers/index';
import {TenantPermissionsService} from "../../_services/tenantPermissions.service";

@Component({
    standalone: false,
  selector: "create-tenant-component",
  templateUrl: 'create.tenant.component.html',
  styleUrls: ['./create.tenant.component.scss'],
})

export class CreateTenantComponent implements OnInit {


  model: any = {};
  loading = false;
  complianceAreas: ComplianceArea[];
  tenantManagerEmailAddress: string;
  role: Role;
  managerEmailAddress: string;
  companyName: string;
  managerEMailPlaceholder: string;
  password: string;
  keyValid: boolean = false;
  secret: string;
  tenantPermissionName: string;

  constructor(
    public router: Router,
    public tenantService: TenantService,
    public complianceAreaService: ComplianceAreaService,
    public authenticationService: AuthenticationService,
    public tenantPermissionsService: TenantPermissionsService,
    public route: ActivatedRoute,
    public alertService: AlertService) {

    this.role = Role.PrimaryManager;
    this.setManagerEMailPlaceholder(this.role);
  }


  ngOnInit() {
    this.secret = this.route.snapshot.params['secret'];
    this.tenantPermissionsService.getTenantPermissionsNameBySecret(this.secret).subscribe(r => {
      this.tenantPermissionName = r;
    });
  }

  onRoleChanged(event) {
    this.setManagerEMailPlaceholder(event);
  }

  setManagerEMailPlaceholder(role: Role) {
    this.managerEMailPlaceholder = role == Role.PrimaryAdvisorLead
      ? 'Manager E-mail'
      : 'Advisor Lead E-mail';
  }

  /*
  allChecked(complianceArea: ComplianceArea): boolean {
      let controlItems = complianceArea.controlItems;

      if (!controlItems) {
        return false;
      }

      var result = controlItems.every(t => t.checked) ? true
          : controlItems.every(t => !t.checked) ? false
          : complianceArea.checked;

      return result;
    }

    someChecked(controlItems: ControlItem[]): boolean {
      const numChecked = controlItems.filter(t => t.checked).length;
      return numChecked > 0 && numChecked < controlItems.length;
    }

  setAllChecked(controlItems: ControlItem[], checked: boolean) {
      controlItems.forEach(t => t.checked = checked);
    }

    */
  onCheck() {


    this.tenantService.checkPassword(this.password).subscribe(t => {

      if (t)
      {
        this.alertService.clear();
        this.keyValid = true;
      }
      else{
        this.alertService.error("Incorrect key");
      }
    });
  }

  onCreate() {
    this.loading = true;

    this.model.Users = [];
    this.model.Users[0] = new User(0);
    this.model.Users[0].emailAddress = this.tenantManagerEmailAddress;
    this.model.Users[0].role = this.role;
    this.model.Users[0].active = false;

    console.log(this.model.Users[0].role);

    //console.log(this.companyName);

    this.model.Companies = [];
    this.model.Companies[0] = new Company();
    this.model.Companies[0].companyName = this.role == Role.PrimaryAdvisorLead ? null : this.companyName;

    this.model.Companies[0].companyType = this.role == Role.PrimaryAdvisorLead
      ? CompanyType.Advisor
      : CompanyType.Client;
    if (this.role == Role.PrimaryAdvisorLead) {
      this.model.Companies[1] = new Company();
      this.model.Companies[1].companyName = this.companyName;
      this.model.Companies[1].companyType = this.role == Role.PrimaryAdvisorLead
        ? CompanyType.Client
        : CompanyType.Advisor;
    }
    this.model.accessKey = this.password;
    this.model.secret = this.secret;
    this.model.tenantName = this.companyName;

    this.tenantService.create(this.model)
      .subscribe(
        data => {
          this.loading = false;
          if (data.error){
            this.alertService.success(data.error, true);
            return;
          }
          this.alertService.success('Account was created.', true);
          const matches = location.host.match(/^([^\/?#]+)(?:[\/?#]|$)/i);
          let domain = matches && matches[1];
          let domainParts = domain.split('.');
          domainParts = domainParts.slice(Math.max(domainParts.length - 2, 0));
          domain = domainParts.join('.');
          location.href = 'https://' + (<any>window).tenantHostnameTemplate.replace('{0}', this.model.Companies[0].companyName || this.model.Companies[1].companyName);
        },
        error => {
          const errorMessage = error.status == 401 ? 'Incorrect key' : 'An error occurred while creating account';
          this.alertService.error(errorMessage);
          this.loading = false;
        });
  }
}
